const apiUrl = "https://proofify-backend.herokuapp.com";

export { apiUrl };
